import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { customStyles } from "../../tableStyles";
import "../css/OrganisationList.css";
import "../css/EmailCopyControl.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faTrash, faCheck } from "@fortawesome/free-solid-svg-icons";
import { formatOrgTypesLabel } from "../../utils/orgTypeHelpers";

function OrganisationList() {
  const [organisations, setOrganisations] = useState([]);
  const [filteredOrganisations, setFilteredOrganisations] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [orgTypes, setOrgTypes] = useState({});
  // const [countries, setCountries] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const orgResponse = await axios.get(`${process.env.REACT_APP_API_URL}/organisations`);
        // const orgTypeResponse = await axios.get(`${process.env.REACT_APP_API_URL}/org-types`);
        // const countryResponse = await axios.get(`${process.env.REACT_APP_API_URL}/countries`);

        // const orgTypesMap = orgTypeResponse.data.reduce((map, type) => {
        //   map[type._id] = type.org_type;
        //   return map;
        // }, {});

        // const countriesMap = countryResponse.data.reduce((map, country) => {
        //   map[country._id] = country.code;
        //   return map;
        // }, {});

        setOrganisations(orgResponse.data);
        setFilteredOrganisations(orgResponse.data);
        // setOrgTypes(orgTypesMap);
        // setCountries(countriesMap);       
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (event) => {

    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = organisations.filter((org) =>
      (org.name || "").toLowerCase().includes(value) ||
      (org.email || "").toLowerCase().includes(value)
    );

    setFilteredOrganisations(filtered);
  };
  
  const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  alert("Email copied!");
};

  const handleDelete = async (org) => {
    if (!window.confirm(`Delete "${org.name}"?`)) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/organisations/${org._id}`);
      setOrganisations((prev) => prev.filter((o) => o._id !== org._id));
      setFilteredOrganisations((prev) => prev.filter((o) => o._id !== org._id));
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete organisation.");
    }
  };

const columns = [
  {
    name: "#",
    cell: (row, index) => index + 1,
    width: "60px",
  },
  {
    name: "Logo",
    cell: (row) => (
      <img
        src={row.logo ? `/images/${row.logo}` : "/images/org_logo1.png"}
        alt={row.name || "Logo"}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "6px",
          objectFit: "contain",
        }}
      />
    ),
    width: "100px",
  },
  {
    name: "Name",
    selector: (row) => row.name,
    cell: (row) => (
      <span
        onClick={() =>
          navigate(`/organisation/${row._id}`, {
            state: { organisation: row },
          })
        }
        style={{
          color :"#000",
          cursor: "pointer",
        }}
      >
        {row.name || "Unnamed Organisation"}
      </span>
    ),
    sortable: true,
  },
  {
    name: "Org. Type",
    selector: (row) => formatOrgTypesLabel(row.org_type_id),
    sortable: true,
  },
  {
    name: "Email",
    selector: (row) => row.email || "-",
    sortable: true,
    style: { paddingLeft: '10px' },
    cell: (row) => (
    <div className="orgns-email-copy-cell">
      <span className="orgns-email-text">{row.email}</span>
      <button
        type="button"
        className="orgns-email-copy-btn"
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard(row.email);
        }}
        title="Copy Email"
      >
      <FontAwesomeIcon icon={faCopy} style={{ color: '#D9A128' }} />
       </button>
       </div>
      )
  },

  {
    name: "Country Code",
    selector: (row) => row.country_id?.code || "N/A",
    sortable: true,
  },

  {
    name: "Los Angeles 2028",
    selector: (row) => (row.status === 1 || row.status === "1" ? "Yes" : "No"),
    cell: (row) => {
      const isLa2028 = row.status === 1 || row.status === "1";
      return (
        <span className="orgns-la2028-cell">
          {isLa2028 ? (
            <>
              Yes <FontAwesomeIcon icon={faCheck} className="orgns-la2028-check" />
            </>
          ) : (
            "No"
          )}
        </span>
      );
    },
    sortable: true,
  },


  {
    name: "Delete",
    cell: (row) => (
      <button
        type="button"
        className="orgns-delete-btn"
        onClick={(e) => { e.stopPropagation(); handleDelete(row); }}
        title="Delete"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    ),
    width: "80px",
  },
];

return(
    <div style={{ background: "transparent", padding: "0px" }}>
      <div className="d-flex justify-content-between mb-1" style={{ marginTop: "40px" }} >
        <div className="w-25 me-3 mb-1">
      {/* Search input */}
      <input
        type="text"
        placeholder="Search by name"
        className = "orgns-search-wrapper form-control search-input"
        value={searchTerm}
        onChange={handleSearch}
        style={{ border: "1px solid #000" }}
      />
    </div>  
     </div>
      <div className="crm-orgns-table-wrapper">
  <DataTable
    columns={columns}
    data={filteredOrganisations}
    progressPending={loading}
    pagination
    paginationPerPage={50}
    paginationComponentOptions={{ noRowsPerPage: true }}
    highlightOnHover
    striped
    responsive
    customStyles={customStyles}
  />
</div>

    </div>
);
  
}

export default OrganisationList;
